import { LauncherGeneratorAotWorker } from './LauncherGenerator';
import { LauncherResourcesJson, LauncherResources } from './LauncherResources';

/* Temporary modify the resources to filter out certain services */
class ModifiedLauncherResources extends LauncherResourcesJson {
    async getOptionValues(option) {
        const result = await super.getOptionValues(option);
        if (option === LauncherResources.LANGUAGE_OPTION) {
            result.options = result.options.filter(opt => opt.value === "JAVA");
        } else if (option === LauncherResources.JAVA_VERSION_OPTION) {
            result.options = result.options.filter(opt => opt.value === "JDK_17" || opt.value === "JDK_21");
        } else if (option === LauncherResources.TEST_OPTION) {
            result.options = result.options.filter(opt => opt.value === "JUNIT" || opt.value === "SPOCK");
        } else if (option === LauncherResources.TYPE_OPTION) {
            result.options = result.options.filter(opt => opt.value !== "SPRING_BOOT_APPLICATION");
        }
        return result;
    }
}

/**
 * A method that allows modifying the parameter values used for generation. Used to change the default parameters
 * if such are required. See the parameterStore.js for usage.
 *
 * @param paramValues An object containing parameter names as keys and the selected value as value.
 */
const optionSelectionModifier = (paramValues) => {
    const DATABASE_FEATURES = ['h2', 'mysql', 'oracle', 'postgres', 'sqlserver', 'mariadb', 'oracle-cloud-atp'];
    if (paramValues.clouds && paramValues.services && paramValues.features &&
        paramValues.clouds['OCI'] && paramValues.services['DATABASE'] &&
        !DATABASE_FEATURES.some(f => paramValues.features[f])
    ) {
        paramValues.features = {...paramValues.features, 'oracle-cloud-atp': true};
    }
    return paramValues;
}

let BASE_URL = "";
if (process.env.REACT_APP_STAGING) {
    BASE_URL = "https://objectstorage.us-phoenix-1.oraclecloud.com/n/oraclelabs/b/gcn-js-files/o/SNAPSHOT%2F";
}

let workerPath;
if (process.env.REACT_APP_GRAALOS) {
    workerPath = 'worker.graalos.js';
} else {
    if (process.env.REACT_APP_STAGING) {
        workerPath = 'worker.staging.js';
    } else {
        workerPath = 'worker.gdk.js';
    }
}

const launcherGenerator = new LauncherGeneratorAotWorker(workerPath);
const launcherResources = new ModifiedLauncherResources(
    fetch(BASE_URL + "select-options.json").then(r => r.json()),
    fetch(BASE_URL + "features.json").then(r => r.json())
);

const configValues = {
    launcherGenerator: launcherGenerator,
    launcherResources: launcherResources,
    optionSelectionModifier: optionSelectionModifier
};
export default configValues;
